/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';

import { useRootSelector } from '../../../hooks/useRootSelector';
import { DocSubheader as NotaryDocSubheader } from '../../NotaryRoom/DocSubheader/DocSubheader';
import { DocSubheader as ParticipantDocSubheader } from '../../ParticipantRoom/DocSubheader/DocSubheader';
import SigningDocument from '../Documents/SigningDocument';

export namespace DocumentSubheader {
  export interface Props {
    isNotary: boolean;
    selectedDocument: SigningDocument | undefined;
    shouldShowSigningIframe: boolean;
  }
}

export const DocumentSubheader: React.FC<DocumentSubheader.Props> = ({
  isNotary,
  selectedDocument,
  shouldShowSigningIframe,
}) => {
  const { signingRoom } = useRootSelector(state => state);
  const { signingAction } = signingRoom;

  if (!selectedDocument || shouldShowSigningIframe) {
    return null;
  }

  if (isNotary) {
    return <NotaryDocSubheader selectedDocument={selectedDocument} signingAction={signingAction} />;
  }

  return <ParticipantDocSubheader selectedDocument={selectedDocument} signingAction={signingAction} />;
};
